export default __webpack_public_path__ + "static/bannerbox.intercable-d2b4e4da0f3d4ae5c7c5f6f8e23675e0.jpg";